import { useQuery } from '@hooks/reactQuery';

import { getConfigurationComparisonTechnologies } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';

import { ICCOptionsProps } from '@interfaces/cmModule/configurationComparison';

import { EVendorsValues, TVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CC_TECHNOLOGIES } from '@constants/queryKeys';

export const useQueryConfigurationComparisonTechnologies = (vendor?: TVendorsValues) => {
	const {
		data: technologiesOptions,
		isFetching: isFetchingTechnologiesOptions,
		isLoading: isLoadingTechnologiesOptions,
	} = useQuery({
		queryKey: [CC_TECHNOLOGIES, vendor],
		queryFn: extractQueryParams(getConfigurationComparisonTechnologies),
		select: (options: Array<ICCOptionsProps>) => options.map(option => ({
			label: option.type.title,
			value: option.type.name,
		})),
		enabled: [!!vendor, vendor !== EVendorsValues.mavenir],
		...refetchOptions,
	});

	return {
		technologiesOptions: technologiesOptions || [],
		isLoadingTechnologiesOptions: isLoadingTechnologiesOptions && isFetchingTechnologiesOptions,
	};
};
